import type { GetV2WorkspacesWorkspaceidFilesQueryParams } from '@emma/api_client/types';
import { useApiFetch } from '../api';

export function useWorkspaceFiles(
  workspaceId: number,
  params: GetV2WorkspacesWorkspaceidFilesQueryParams = {}
) {
  return useApiFetch(
    `workspaces/${workspaceId}/files?${JSON.stringify(params)}`,
    async (callApi) =>
      await callApi((api) => api.files.getV2WorkspacesWorkspaceidFiles({ workspaceId }, params)),
    { keepPreviousData: true }
  );
}
